/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPORT : CTA : UPLOAD : STYLES --------------- ++++++++++ */
export default theme => ({
    upload: {
        display: 'flex',
        alignItems: 'center',
        '& .file-name': {
            width: pxToEm(150),
            '& .file-uploaded': {
                display: 'flex',
                flexDirection: 'column',
                '& .discard': {
                    color: theme.color.attention.medium.contrast,
                    cursor: 'pointer'
                },
                '& .file-name-text': {
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis',
                }
            }
        },
        '& .input-button': {
            height: pxToEm(48),
            width: pxToEm(213),
            position: 'relative',
            border: pxToEm(2),
            borderRadius: pxToEm(4),
            background: theme.color.neutral.light.swatch,
            marginRight: pxToEm(10),
            '&.disabled-true': {
                pointerEvents: 'none',
                '& .button-text': {
                    color: theme.color.neutral.medium.swatch
                }
            },
            '& input': {
                position: 'absolute',
                height: '100%',
                width: '100%',
                cursor: 'pointer',
                opacity: 0,
                zIndex: 2
            },
            '& ::-webkit-file-upload-button': {
                cursor: 'pointer'
            },
            '& .button-text': {
                position: 'absolute',
                maxWidth: '15ch',
                width: 'fit-content',
                left: '50%',
                top: '50%',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                transform: 'translate(-50%,-50%)',
                color: theme.color.primary.medium.swatch
            }
        }
    }
});
